import { PAYMENT_GATEWAYS_API } from 'modules/profile/payment-gateways/api/payment-gateways-api'
import { PaymentFlutterwaveInterface } from 'modules/profile/payment-gateways/integrations/flutterwave/types'
import httpClient from 'shared/utils/http-client'

export const flutterwaveConnect = (data: PaymentFlutterwaveInterface) =>
  httpClient.post(`${PAYMENT_GATEWAYS_API}/flutterwave/connect`, data)

export const flutterwaveDisconnect = () =>
  httpClient.post(`${PAYMENT_GATEWAYS_API}/flutterwave/disconnect`)
